import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

const newFaxLoadingViewStyleParts = ['container', 'circularProgress'] as const

const helpers = createMultiStyleConfigHelpers(newFaxLoadingViewStyleParts)
export const NewFaxLoadingViewStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      alignItems: 'center',
      justifyItems: 'center',
      gap: '1.5rem',
      py: '1.75rem',
      px: '1.5rem',
      userSelect: 'none',
      backgroundColor: 'transparent',
    },
    circularProgress: {
      width: '6px',
      height: '9rem',
      backgroundColor: 'bg.muted',
      color: 'brand.fg',
    },
  },
})

export const useNewFaxLoadingViewStyle = (props?: StyleThemingProps) =>
  mergeMultiStyleConfig(NewFaxLoadingViewStyle, props) as MultiStyleType<
    typeof newFaxLoadingViewStyleParts
  >
